import { useEffect, useState } from 'react';

export const useContainerWidth = (ref) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref?.current) return;

    const updateWidth = () => {
      if (ref?.current) {
        setWidth(ref.current.clientWidth);
      }
    };

    updateWidth();

    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(ref.current);

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return width;
};
